export default __webpack_public_path__ + "static/media/1096.972a0ca0.png";